module.exports = __webpack_public_path__ + "img/espacePatient.3456bee7.png";